import { graphql } from "gatsby";
import * as React from "react";
import { Base, Box, Button, Container, Flex, Section, Text } from "./ui";
import * as styles from "./ui.css";
import ReactHtmlParser from 'react-html-parser'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import moment from 'moment';

const useFetchPosts = () => {
  const [data, setData] = React.useState(null);
  const url = process.env.GATSBY_WORDPRESS_HOST + '/wp-json/wp/v2/posts?page=1&per_page=3&context=embed&tags=113';
  React.useEffect(() => {
    async function loadData() {
      const response = await fetch(url).catch((err) => {
        return { ok: false };
      });
      if (!response.ok) {
        return;
      }

      const posts = await response.json();
      setData(posts.splice(0, 3));
    }

    loadData();
  }, []);
  return data;
}

const convertURL = (path) => {
  const url = new URL(path);
  return process.env.GATSBY_WORDPRESS_HOST + url.pathname;
}

const BlogContent = (props) => {
  const posts = useFetchPosts();
  return (
    <Base as="div" cx={[styles.blogPosts]}>
      <Base as="div" cx={[styles.blogPostsSpacer]}></Base>
      {posts && posts.map(({ yoast_head_json, link, wbCategories, ...rest }, index) => {
        console.log('Posts: ', yoast_head_json, link, wbCategories, rest);
        return (
          <Base as="a" href={link} target="_blank" cx={[styles.blogPostLink]}>
            <Base as="div" cx={[styles.blogPost]}>
              <Base as="img" cx={[styles.blogPostCover]} src={convertURL(yoast_head_json.og_image[0].url)} />
              <Base as="div" cx={[styles.blogPostTexts]}>
                {wbCategories && (<Text variant="herobody" cx={[styles.categoriesLink]}>{ReactHtmlParser(wbCategories.coma)}</Text>)}
                <Text cx={[styles.blogPostTitle]}>{yoast_head_json.title}</Text>
                <Text cx={[styles.blogPostSubtitle]}>
                  {moment(yoast_head_json.article_published_time).format("DD/MM/YYYY")}
                  &nbsp;
                  <FontAwesomeIcon icon={faClock} />
                  &nbsp;
                  {yoast_head_json.twitter_misc["Est. tempo de leitura"] + ' de leitura'}
                </Text>
              </Base>
            </Base>
          </Base>
        )
      })}
    </Base>
  );
}

export default function HomepageFaq(props) {
  return (
    <Base as="div" cx={[styles.blogSection]}>
      <Base as="div" cx={[styles.blogBackgroundSection]}>
        <Flex cx={[styles.herosectionFlex]} gap={0}>
          <Base as="div" cx={[styles.blogImageBox]}>
            <Flex cx={[styles.blogBackgroundFlex]} gap={0}>
              <Base as='div' cx={[styles.rightBlogBackContainerFitness]} />
              <Base as='div' cx={[styles.rightBlogBackContainerMind]} />
              <Base as='div' cx={[styles.rightBlogBackContainerMedical]} />
              <Base as='div' cx={[styles.rightBlogBackContainerFinancial]} />
            </Flex>
          </Base>
          <Base as="div" cx={[styles.herosectionTextBoxOuter]}>
          </Base>
        </Flex>
      </Base>
      <Base as="div" cx={[styles.blogContent]}>
          <Flex cx={[styles.blogTexts]}>
            <Base as="div" cx={[styles.blogTitle]}>
              <Text variant="blogbody">
                {ReactHtmlParser(props.heading)}
              </Text>
              <Button cx={[styles.blogButton]} to={'https://gogood.com.br/blog'} variant='primary'>
                Acesse nosso blog <FontAwesomeIcon icon={faArrowRightLong} />
              </Button>
            </Base>
            <BlogContent />
          </Flex>
      </Base>
    </Base>
  )
}

export const query = graphql`
  fragment HomepageFaqContent on HomepageFaq {
    id
    heading
    questions {
      id
      question
      answer
    }
  }
`
